import React from 'react';
import DefaultQuestionnaireModal from './DefaultQuestionnaireModal';

interface SwitchDefaultModalProps {
  isOpen: boolean;
  newQuestionnaireName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const SwitchDefaultModal: React.FC<SwitchDefaultModalProps> = ({
  isOpen,
  newQuestionnaireName,
  onConfirm,
  onCancel,
}) => {
  return (
    <DefaultQuestionnaireModal
      isOpen={isOpen}
      position="top"
      onClose={onCancel}
      footer={
        <div className="dq-modal-footer">
          <button className="dq-btn dq-btn--cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="dq-btn dq-btn--primary" onClick={onConfirm}>
            Confirm
          </button>
        </div>
      }
    >
      <h3 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '1rem', color: '#181C32' }}>Switch Default Questionnaire</h3>
      <p>
        Going forward, {newQuestionnaireName} will be automatically applied
        to all new job postings. This change will not impact existing jobs with questionnaires already attached.
      </p>
    </DefaultQuestionnaireModal>
  );
};

export default SwitchDefaultModal;
